export default __webpack_public_path__ + "static/media/shadow.2a045a9b.svg";